import React, {useState} from 'react';
import Table from "../../../components/Table";
import moment from "moment";
import PricelistDetail from "./detail";
import {Button} from "antd";
import {PlusOutlined} from "@ant-design/icons";

const PricelistTable = () => {

    const [detailId, setDetailId] = useState(null);
    const [toggleReloadState, setToggleReloadState] = useState(null);

    const toggleReload = () => {
        setToggleReloadState(Math.random(5));
    };

    const closeDetail = () => {
        setDetailId(null);
        toggleReload();
    };



    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: 'Erstellt',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: true,
            render: (data) => `${moment(data).format('DD.MM.YYYY HH:mm')} Uhr`
        },

    ];

    return (<>
            <PricelistDetail
                id={detailId}
                close={closeDetail}
            />

            <div style={{marginBottom: '15px', textAlign: 'right'}}>
                <Button
                    type={"primary"}
                    icon={<PlusOutlined />}
                    onClick={() => setDetailId("new")}
                >
                    Hinzufügen
                </Button>
            </div>

            <Table
                endpoint={'pricelist'}
                columns={columns}
                sortField={'createdAt'}
                sortOrder={'descend'}
                onClick={(record) => setDetailId(record.id)}
                toggleReload={toggleReloadState}
            />
        </>
    );
}

export default PricelistTable;
